
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';
import { PersonalDocument } from 'src/app/models/personal-document.model';
import { PersonalEmail } from 'src/app/models/personal-email.model';
import { environment } from 'src/environments/environment';
import moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class MyCloudService {

	private baseMyCloudUrl = `${environment.baseUrl}/mycloud`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	getMyCloudDocuments(token: string): Observable<PersonalDocument[]> {
		return this.httpClient.get<PersonalDocument[]>(`${this.baseMyCloudUrl}/${token}/documents`);
	}

	@ApiMethod()
	getMyCloudEmail(token: string, emailId: number): Observable<PersonalEmail> {
		return this.httpClient.get<PersonalEmail>(`${this.baseMyCloudUrl}/${token}/emails/${emailId}`);
	}

	@ApiMethod()
	mapMyCloudDocumentsToJob(token: string, documentIds: number[], { documentTypeMappingId, description, additionalAssets, documentationAssetTypes, effectiveDate, descriptiveTagId, calendarBasedTagIds }): Observable<void> {
		const formData = new FormData();
		documentIds.forEach(id => formData.append('documentIds[]', id.toString()));

		formData.append('documentTypeMappingId', documentTypeMappingId);
		formData.append('description', description || '');

		if (effectiveDate) {
			formData.append('effectiveDate', moment.parseZone(effectiveDate).format('MM/DD/YYYY'));
		}

		if (descriptiveTagId) {
			formData.append('descriptiveTagId', descriptiveTagId);
		}

		if (additionalAssets) {
			additionalAssets.forEach(item => formData.append('additionalAssetIds[]', item));
		}

		if (documentationAssetTypes) {
			documentationAssetTypes.forEach(item => formData.append('documentationAssetTypeIds[]', item));
		}

		if (calendarBasedTagIds) {
			calendarBasedTagIds.forEach(item => formData.append('calendarBasedTagIds[]', item));
		}

		return this.httpClient.post<void>(`${this.baseMyCloudUrl}/${token}/documents`, formData);
	}
}
